export default {
    AIRLINES: 'airlines',
    ARRIVAL_AIRPORTS_LEG_ONE: 'arrivalAirportLeg1',
    ARRIVAL_AIRPORTS_LEG_TWO: 'arrivalAirportLeg2',
    DEPARTURE_AIRPORTS_LEG_ONE: 'departureAirportLeg1',
    DEPARTURE_AIRPORTS_LEG_TWO: 'departureAirportLeg2',
    DURATION_TO: 'durationTo',
    CABIN_TYPES: 'cabinType',
    INBOUND_ARRIVAL_TIME: 'inboundArrivalTime',
    INBOUND_DEPARTURE_TIME: 'inboundDepartureTime',
    NUMBER_OF_STOPS: 'maximumNumberOfStops',
    OUTBOUND_ARRIVAL_TIME: 'outboundArrivalTime',
    OUTBOUND_DEPARTURE_TIME: 'outboundDepartureTime',
    PRICE_TO: 'priceTo',
    SORT_BY_BEST: 'agony_asc',
    SORT_BY_DURATION: 'tripDuration_asc',
    SORT_BY_PRICE: 'priceAmount_asc',
    SORT_BY_CO2: 'tonsOfCo2_asc',
    SORT_CRITERIA: 'sortCriteria',
    STOPOVER_AIRPORTS: 'stopoverAirports',
};
